/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
// eslint-disable-next-line no-restricted-imports
import { IconName } from 'common/components/controls/icon';
// eslint-disable-next-line no-restricted-imports
import { Noun, Verb } from 'common/debug/analytics-constants';
// eslint-disable-next-line no-restricted-imports
import { EnterpriseMenuPopoverId } from 'components/popovers/popover-ids';
// eslint-disable-next-line no-restricted-imports
import analytics from 'debug/analytics';
// eslint-disable-next-line no-restricted-imports
import { showPopover, State } from 'modules';
import React, { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
// eslint-disable-next-line no-restricted-imports
import { isEnterpriseAdmin } from 'selectors/enterprises';
// eslint-disable-next-line no-restricted-imports
import { isPopoverShown } from 'selectors/popovers';
import HeaderButton from './button';

const EnterpriseMenuPopoverPromise = import(/* webpackChunkName: "gamma-enterprise-menu-popover" */ 'components/popovers/enterprise-menu');
const EnterpriseMenuPopover = lazy(() => EnterpriseMenuPopoverPromise);

interface StateProps {
  isActive: boolean;
  isAdmin: boolean;
}

interface DispatchProps {
  onClick: () => void;
}

type AllProps = StateProps & DispatchProps;

class EnterpriseMenuButton extends React.Component<AllProps> {
  menuButtonRef = React.createRef<HTMLButtonElement>();

  render() {
    const { onClick, isActive, isAdmin } = this.props;
    if (!isAdmin) {
      return null;
    }

    return (
      <>
        <HeaderButton
          icon={IconName.Enterprise}
          onClick={onClick}
          ref={this.menuButtonRef}
          testId={HeaderTestIds.EnterpriseDashboardButton}
        />
        {isActive && (
          <Suspense fallback={null}>
            <EnterpriseMenuPopover target={() => this.menuButtonRef.current} />
          </Suspense>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: State): StateProps => ({
  isActive: isPopoverShown(state, EnterpriseMenuPopoverId),
  isAdmin: isEnterpriseAdmin(state),
});

const mapDispatchToProps = (dispatch: Dispatch<State>): DispatchProps => ({
  onClick() {
    analytics.trackUE({
      category: Noun.HEADER,
      verb: Verb.OPENS,
      directObj: Noun.ENTERPRISE_DASHBOARD_MENU,
      method: 'by clicking enterprise button in header',
    });
    dispatch(showPopover({ name: EnterpriseMenuPopoverId }));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EnterpriseMenuButton);



// WEBPACK FOOTER //
// ./app/gamma/src/components/header/enterprise-menu-button.tsx